import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';
import QuestionPercentage from './AnswerPercentage/QuestionPercentage'
import getPercentQuestionData from '../../../helpers/assessment/getPercentQuestionData';
import forOwn from 'mout/object/forOwn'
import AnswerPercentagePageWrapper from './AnswerPercentage/AnswerPercentagePageWrapper'

export default function AnswerPercentagePages ({isGroup, assessmentSubtests, items, nodes, answersByItem, destructuredSubtests, headerText}) {
  const colNames = {
    1: 'first',
    2: 'second',
    3: 'third',
    4: 'fourth',
  }
  let pages = []
  const subtests = sortByPropText(values(assessmentSubtests), 'index')
  subtests.forEach((subtest) => {
    if (answersByItem && answersByItem[subtest.setId] && items) {
      const MAX_ITEMS = subtest.displayName === 'Math' ? 8 : 10
      let cols = []
      let questions = []
      const subtestId = subtest.setId
      const answers = answersByItem[subtestId]
      const subtestItems = destructuredSubtests[subtestId].items
      let colNum = 1
      let colCount = 0
      let pageNum = 0
      subtestItems.forEach((sI, i) => {
        // const data = answers[sI] ? getPercentQuestionData(items[sI], answers[sI], nodes) : null
        const data = getPercentQuestionData(items[sI], answers && answers[sI], nodes)
        if (data) {
          questions.push(
            <QuestionPercentage
              key={sI}
              number={(i + 1)}
              startingLetter={i % 2 === 0 ? 'a' : 'f'}
              percents={data.percents}
              correct={data.correct}
              skill={{name: data.skill, link: 'https://www.masteryprep.com'}}
            />
          )
          colCount++
          if (colCount === MAX_ITEMS) {
            cols.push(
              <div className={`column ${colNames[colNum]}-column`} key={`Perc${subtest.displayName}${colNum}`}>
                {questions}
              </div>
            )
            questions = []
            if (colNum > 3) {
              colNum = 1
              pages.push(
                <AnswerPercentagePageWrapper 
                  name={subtest.displayName} 
                  key={`perc${subtest.displayName + pageNum}`}
                  headerText={headerText}  
                >
                  {cols}
                </AnswerPercentagePageWrapper>
              )
              pageNum++
              cols = []
            } else {
              colNum++
            }
            colCount = 0
          }
        } 
      })
      if (questions.length > 0) {
        cols.push(
          <div className={`column ${colNames[colNum]}-column`} key={`Perc${subtest.displayName}${colNum}`}>
            {questions}
          </div>
        )
      }
      if (cols.length > 0) {
        pages.push(
          <AnswerPercentagePageWrapper
            name={subtest.displayName} 
            key={`perc${subtest.displayName + pageNum}`}
            headerText={headerText}
          >
            {cols}
          </AnswerPercentagePageWrapper>
        )  
      }
    }
  })
   



  return (
    <div>
      {pages}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AnswerPercentagePages.js